module.exports = __webpack_public_path__ + "img/AnunciosdeMáximoRendimiento.2c7b9789.svg";